import type { PublishedSnippet } from "../../types";

export const SNIPPET_TYPE_COLOR: Record<PublishedSnippet["type"], string> = {
  css: "blue",
  html: "volcano",
  js: "gold",
  php: "purple",
  text: "default",
};

export const SNIPPET_TYPE_LANGUAGE: Record<PublishedSnippet["type"], string | undefined> = {
  css: "css",
  html: "markup",
  js: "javascript",
  php: "php",
  text: undefined,
};
